import { LegalClientFirstHeadEntity } from 'api/types/entity';
import { isFinanceProject, isGlobalProject } from 'config';
import { CountryRiskField } from 'modules/client/common/feature';

import { LegalClientFirstHeadMainInfoType } from '../types';

const getLegalClientFirstHeadMainInfoForGlobal = (
  legalClientFirstHead: LegalClientFirstHeadEntity
): LegalClientFirstHeadMainInfoType => ({
  citizenship: legalClientFirstHead.citizenships?.[0],
  email: legalClientFirstHead.email,
  position: legalClientFirstHead.position?.position,
  country: legalClientFirstHead.residentialAddress?.country,
  countryRiskField: CountryRiskField.ResidentialAddress,
  dateOfExpiration: legalClientFirstHead.position?.expirationDate,
});

const getLegalClientFirstHeadMainInfoForFinance = (
  legalClientFirstHead: LegalClientFirstHeadEntity
): LegalClientFirstHeadMainInfoType => ({
  email: legalClientFirstHead.email,
  position: legalClientFirstHead.position?.position,
  country: legalClientFirstHead.registrationAddress?.country,
  countryRiskField: CountryRiskField.RegistrationAddress,
  dateOfExpiration: legalClientFirstHead.position?.expirationDate,
});

export const getLegalClientFirstHeadMainInfo = (
  legalClientFirstHead: LegalClientFirstHeadEntity
): LegalClientFirstHeadMainInfoType | undefined => {
  if (isGlobalProject()) {
    return getLegalClientFirstHeadMainInfoForGlobal(legalClientFirstHead);
  }
  if (isFinanceProject()) {
    return getLegalClientFirstHeadMainInfoForFinance(legalClientFirstHead);
  }
  return undefined;
};
